import { useDownloadPositionAssignmentPdf } from '@src/main/modules/reports/positionassignment/application/hook/useDownloadPositionAssignment';
import { PositionAssignmentReport } from '@src/main/modules/reports/shared/domain/report.interface';
import { getTimestamp } from '@src/main/shared/utils/dateUtils';
import { logger } from '@src/main/shared/utils/logger';
import { saveAs } from 'file-saver';
import { useCallback } from 'react';

export const usePositionAssignmentActions = () => {
  const { mutateAsync: downloadPdfMutation } = useDownloadPositionAssignmentPdf();

  /**
   *
   * Descargar PDF del informe
   */
  const downloadPdf = useCallback(
    async (report: PositionAssignmentReport) => {
      try {
        const blob = await downloadPdfMutation(report.id ?? '');

        const fileName = `position_assignment_${report.flightNumber ?? 'NA'}_${
          report.flightDate ?? 'NA'
        }_${report.departureAirport ?? 'NA'}_${
          report.arrivalAirport ?? 'NA'
        }_${getTimestamp()}.pdf`;

        saveAs(blob, fileName);
      } catch (error) {
        logger.error('Error downloading Position Assignment PDF', error);
      }
    },
    [downloadPdfMutation],
  );

  return downloadPdf;
};
